import { parseISO, isValid, format } from 'date-fns';

import { DD_MM_YYYY, REGULAR_TIME_FORMAT } from 'Constants/dateTime';
import { INVALID_DATE } from 'Constants/errors';

const CurrencyFormatter = Intl.NumberFormat('en-IN', {
    currency: 'INR',
    style: 'currency',
});

// Parse and format date time to specified format
export function parseAndFormat(
    date?: string,
    dateFormat: string = DD_MM_YYYY
): string {
    try {
        if (!date) {
            return '';
        }
        try {
            return format(parseISO(date), dateFormat);
        } catch {
            return format(new Date(date), dateFormat);
        }
    } catch {
        return INVALID_DATE;
    }
}

export function toTitleCase(text?: string): string {
    if (!text) {
        return '';
    }

    return text
        .trim()
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/^[a-z|A-Z]/g, (char: string) => char.toUpperCase());
}

export function toSentenceCase(text?: string): string {
    if (!text) {
        return '';
    }

    return text.split('.').map(toTitleCase).join('. ');
}

export function amountToINRString(amount?: number | null): string {
    if (!Number.isInteger(amount)) {
        amount = Number(amount);
    }
    // If no decimals, remove extra 0's
    return CurrencyFormatter.format(amount || 0).replace(/\.00$/, '');
}
export const formatCurrency = (amount: string | number) => {
    if (!amount) return '';
    const roundedAmount = Math.round(Number(amount));
    return amountToINRString(roundedAmount);
};

export function getMaskedAccountNumber(
    accountNumber?: number | string,
    unmaskLength = 4
): string {
    if (!accountNumber) {
        return '';
    }

    const value = accountNumber.toString();
    const { length } = value;

    if (length < unmaskLength) {
        return value;
    }
    return (
        `*`.repeat(length - unmaskLength) + value.slice(length - unmaskLength)
    );
}

export function capatilizeName(text: string): string {
    if (!text) {
        return '';
    }

    return text.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatAMPM(date: Date) {
    let hours = date?.getHours();
    const minutes = date?.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours || 12; // the hour '0' should be '12'
    return `${hours}:${minutes < 10 ? 0 : ''}${minutes} ${ampm}`;
}

export function createTimeSlotText(date: Date, format?: string) {
    try {
        if (date)
            return parseAndFormat(
                new Date(date) as any,
                format || REGULAR_TIME_FORMAT
            );
        return '';
    } catch (e) {
        return '';
    }
}

export function formatDate(dateString: string) {
    const date = parseISO(dateString);
    return format(date, 'do MMMM yyyy');
}
